import { render } from "./CommunityGuidelinesCodeOfConduct.vue?vue&type=template&id=62097064&scoped=true"
import script from "./CommunityGuidelinesCodeOfConduct.vue?vue&type=script&lang=js"
export * from "./CommunityGuidelinesCodeOfConduct.vue?vue&type=script&lang=js"

import "./CommunityGuidelinesCodeOfConduct.vue?vue&type=style&index=0&id=62097064&scoped=true&lang=scss"
import "./CommunityGuidelinesCodeOfConduct.vue?vue&type=style&index=1&id=62097064&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62097064"]])

export default __exports__